import angular from 'angular';

import Component from './manage-attribute.component';

const Module = angular
    .module('control.room.commons.content.components.manage-attribute', [])
    .component('crManageAttribute', Component);

export default Module;
